<template>
  <div>
    <el-popover placement="top-start" width="200" trigger="hover">
      <div>
        <div>wx_id: {{ value.wx_id }}</div>
        <div>类型: {{ value.account_type }}</div>
        <div>项目:{{ value.project_name }}</div>
        <div class="ac p10 br10 box-s">
          用户:

          <XAdminUserInfo :value="value.user" />
        </div>
      </div>
      <div slot="reference">wx_id: {{ value.wx_id }}</div>
    </el-popover>
  </div>
</template>

<script>
  export default {
    props: {
      value: {
        type: null,
        default: null
      }
    },

    data() {
      return {
        localData: null
      }
    },

    created() {
      this.localData = this.value
    },
    methods: {}
  }
</script>

<style lang="scss" scoped></style>
